import { BLUE } from "@/config/mui/colorPalette";

type Props = {
  size?: string;
};

export default function InfoCircleIconSvg({ size = "200" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="200" height="200" rx="100" fill={BLUE[20]} />
      <path
        d="M86 69.5C86 65.3579 89.3579 62 93.5 62H106.5C110.642 62 114 65.3579 114 69.5C114 73.6421 110.642 77 106.5 77H93.5C89.3579 77 86 73.6421 86 69.5Z"
        fill={BLUE[60]}
      />
      <path
        d="M86 94C86 90.134 89.134 87 93 87H107C110.866 87 114 90.134 114 94V130C114 133.866 110.866 137 107 137H93C89.134 137 86 133.866 86 130V94Z"
        fill={BLUE[60]}
      />
      <path
        d="M86 69.5C86 65.3579 89.3579 62 93.5 62C97.6421 62 101 65.3579 101 69.5C101 73.6421 97.6421 77 93.5 77C89.3579 77 86 73.6421 86 69.5Z"
        fill="white"
      />
      <path
        d="M86 94.5C86 90.3579 89.3579 87 93.5 87C97.6421 87 101 90.3579 101 94.5V129.5C101 133.642 97.6421 137 93.5 137C89.3579 137 86 133.642 86 129.5V94.5Z"
        fill="white"
      />
      <path
        d="M93.5 77H106.5C110.642 77 114 73.6421 114 69.5C114 65.3579 110.642 62 106.5 62H93.5M93.5 77C89.3579 77 86 73.6421 86 69.5C86 65.3579 89.3579 62 93.5 62M93.5 77C97.6421 77 101 73.6421 101 69.5C101 65.3579 97.6421 62 93.5 62M93 137H107C110.866 137 114 133.866 114 130V94C114 90.134 110.866 87 107 87H93C89.134 87 86 90.134 86 94V130C86 133.866 89.134 137 93 137ZM93.5 137C89.3579 137 86 133.642 86 129.5V94.5C86 90.3579 89.3579 87 93.5 87C97.6421 87 101 90.3579 101 94.5V129.5C101 133.642 97.6421 137 93.5 137Z"
        stroke={BLUE[100]}
        strokeWidth="2"
      />
    </svg>
  );
}
